import { dynamicPx, flexColumn, TextTypography } from 'components/common/Common';
import React from 'react';
import styled from 'styled-components';
import { camelCase } from 'untils';
import { flexGap } from 'untils/polyfill/flex';
import aircraftJson from '../data.json';
import {
  BlurBackgroundName,
  CenterContent,
  contentWidth,
  InfoIcon,
  MoreLink,
  SectionContainer,
} from '../JetSale.style';
import JetSaleContact from './JetSaleContact';

const CategoryAircraftContainer = styled.section`
  ${flexColumn}
  ${flexGap('.5em')}
  margin: min(4%, 1.5em) 0;
`;
const AircraftDisplayContainer = styled.article`
  display: grid;
  color: var(--white);
  ${flexGap('.5em')}
  grid-template-columns: repeat(auto-fill, minmax(307px, 1fr) );
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Container = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AircraftContainer = styled.div`
  ${flexColumn}
  --aspect_ratio_wrapper-ratio: 16 / 10;
  width: 100%;
  aspect-ratio: var(--aspect_ratio_wrapper-ratio);
  justify-self: center;
  position: relative;
  background: no-repeat center / cover url(${(props) => props.image});
  justify-content: space-between;
  padding: ${dynamicPx({ minSize: 8, maxSize: 16, minVW: 320 })};
  border-radius: 8px;
`;

const SeatContainer = styled(Container)`
  justify-content: flex-start;
`;

const MainContainer = styled(SectionContainer)`
  margin-top: var(--standard-top-padding);
  max-width: 1300px;
  @media (max-width: 1316px) {
    ${contentWidth}
    min-width: 304px;
  }
`;

const TitleContainer = styled(CenterContent)`
  margin-top: ${dynamicPx({ minSize: 45, maxSize: 80 })};
  margin-bottom: 1em;
`;

const AircraftShowcase = () => {
  return (
    <MainContainer>
      <SectionContainer>
        <TitleContainer as="div">
          <InfoIcon $dynamicSize={{ minSize: 170, maxSize: 376 }} $autoHeight>
            <img src={'/imgs/webp/jetSale/text1.webp'} alt="Available Airplanes" />
          </InfoIcon>
        </TitleContainer>

        {aircraftJson.map(({ category, aircraft }) => (
          <CategoryAircraftContainer key={category}>
            <Container>
              <TextTypography fontWeight={700} $color={'#0063DB'}>
                {category}
              </TextTypography>
              <MoreLink to={{ pathname: `/jetSale/${camelCase(category)}` }}>
                <TextTypography
                  step={-2}
                  $color={'#0063DB'}
                  fontWeight={700}
                  style={{ lineHeight: '1' }}
                >
                  More...
                </TextTypography>
              </MoreLink>
            </Container>
            <AircraftDisplayContainer>
              {aircraft
                .filter((air) => air.display)
                .sort((a, b) => a.order - b.order)
                .map((air, i) => (
                  <AircraftContainer
                    key={air.aircraft}
                    image={`/imgs/webp/jetSale/${`${category === 'Heavy Jets' ? 'heavy' : 'mid'}${
                      i + 1
                    }`}.webp`}
                  >
                    <BlurBackgroundName>
                      <TextTypography fontWeight={700} $maxSize={16} $minSize={12} $color={'#fff'}>
                        {air.aircraft}
                      </TextTypography>
                    </BlurBackgroundName>
                    <SeatContainer>
                      <InfoIcon width={24} height={24}>
                        <img src={'/imgs/svg/seat.svg'} alt="seat icon" />
                      </InfoIcon>
                      <TextTypography fontWeight={700} $maxSize={16} $minSize={12} $color={'#fff'}>
                        {air.seats} Seats
                      </TextTypography>
                    </SeatContainer>
                  </AircraftContainer>
                ))}
            </AircraftDisplayContainer>
          </CategoryAircraftContainer>
        ))}
      </SectionContainer>
      <JetSaleContact />
    </MainContainer>
  );
};

export default AircraftShowcase;
